module.exports = __webpack_public_path__ + "img/01.490c4a98.png";